import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { LearningPlanService } from "src/app/_services/learning-plan.service";
import { AddExternalInitialAssessment, AddExternalInitialAssessmentError, AddExternalInitialAssessmentSuccess } from "./external-initial-assessment.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { ExternalInitialAssessment } from "src/app/_models/ExternalInitialAssessmentDto";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";

@Injectable()
export class ExternalInitialAssessmentEffects {
  constructor(
    private action$: Actions,
    private learningPlanService: LearningPlanService
  ) {}

  public createExtInitialAssessmentEffect$ = createEffect(() =>
    this.action$.pipe(
      ofType(AddExternalInitialAssessment),
      switchMap((payload) =>
        this.learningPlanService
        .createExternalInitialAssessment$(payload.params)
        .pipe(
          map((result : ExternalInitialAssessment) => {
            return AddExternalInitialAssessmentSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(AddExternalInitialAssessmentError({error: error}));
          })
        )
      )
    )
  );
}